<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <!-- <adl-view ref="adl" /> -->
    <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs12>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12 md1 class="mb-2">
          <v-btn
            fab
            small
            @click="printTable()"
            class="ml-8 white--text"
            color="#2b6993"
            elevation="4"
            absolute
            right
          >
            <v-icon>print</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12>
          <h3 class="text-center mb-5">Unsigned ADL Report</h3>
          <v-divider class="ml-4 mr-4 mb-3"></v-divider>
        </v-flex>

        <v-flex xs12>
          <v-card class="ma-3 pa-3" elevation="0">
            <v-layout row wrap>
              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  v-model="calendarMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="startDate"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="requiredField"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    @input="calendarMenu = false"
                    no-title
                    :rules="requiredField"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  v-model="calendar2Menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    @input="calendar2Menu = false"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <!-- <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Signed/Unsigned"
                  :items="status"
                  item-text="Name"
                  item-value="Name"
                  v-model="selectedStatus"
                  clearable
                  @change="adlQuery"
                ></v-select>
              </v-flex> -->

              <!-- <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Select a Program"
                  :items="programs"
                  item-text="Name"
                  item-value="Name"
                  v-model="program"
                  clearable
                ></v-select>
              </v-flex> -->

              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Select a Client"
                  :items="clients"
                  item-text="Name"
                  item-value="_id"
                  v-model="ClientID"
                  clearable
                ></v-select>
              </v-flex>

              <v-flex xs12 md1 class="mt-5 mb-5 pl-5">
                <v-btn small @click="adlQuery()">Search</v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 class="pa-2">
          <v-data-table
            :headers="headers"
            :items="adls"
            sort-by="Date"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading ADLS"
            :items-per-page="-1"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                class="ma-2"
                :color="item.status === 'Unsigned' ? 'yellow' : 'green'"
                x-small
              >
                <span
                  :class="
                    item.status === 'Unsigned' ? 'black--text' : 'white--text'
                  "
                  >{{ item.status }}</span
                >
              </v-chip>
            </template>

            <template v-slot:item.select="{ item }">
              <v-btn
                x-small
                class="white--text"
                color="#2b3990"
                @click="viewADL(item)"
              >
                view
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialog" max-width="75%">
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="newService"
                    label="Service"
                    :disabled="true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="newTime"
                    label="ADL Time"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    v-model="newAssistance"
                    label="Level of Assistance"
                    :items="assistance"
                    :rules="requiredRules"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="newException"
                    label="Exception"
                    :items="exception"
                    :rules="requiredRules"
                  ></v-autocomplete>
                </v-col>
                <v-col class="d-flex" cols="6" sm="6">
                  <v-textarea v-model="newNotes" label="Notes"></v-textarea>
                </v-col>
                <v-col
                  class="d-flex"
                  cols="6"
                  sm="6"
                  style="position:relative;"
                >
                  <v-text-field
                    class="update-icon"
                    v-model="newSignature"
                    label="Signature"
                    append-icon="mdi-pencil-box-outline"
                    @click:append="onUpdateSignature()"
                    v-if="canUpdate"
                  ></v-text-field>
                  <v-text-field
                    class="update-icon"
                    v-model="newSignature"
                    label="Signature"
                    readonly
                    disabled
                    v-if="!canUpdate"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn class="blue darken-2 white--text" text @click="addADL()" v-if="newService">Save</v-btn
                                > -->
          <v-btn color="blue darken-1" text @click="onUpdateItem" v-if="editADL"
            >Update</v-btn
          >
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="print">
      <h2 class="text-center ma-3">Unsigned ADL Report</h2>
      <v-row>
        <v-col cols="4">
          <v-text-field
            v-model="startDate"
            label="Start Date"
            prepend-icon="mdi-calendar"
            readonly
            :rules="requiredField"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="endDate"
            label="End Date"
            prepend-icon="mdi-calendar"
            readonly
            :rules="requiredField"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-select
            label="Select a Client"
            :items="clients"
            item-text="Name"
            item-value="_id"
            v-model="ClientID"
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="adls"
            sort-by="Date"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading ADLS"
            :items-per-page="-1"
          >
            <template v-slot:item.select="{ item }">
              <v-btn
                x-small
                class="white--text"
                color="#2b3990"
                @click="viewCertification(item)"
              >
                View
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import axios from "axios";
// import Foot from '../components/Footer'
// import AdlView from "@/components/serviceplan/adl/AdlView";
import { setUserTz, tz } from "../../../utils/timezone";

const url = require("../../client_config/config").url;

export default {
  props: {
    itemData: {
      type: Object,
    },
    updatedSignature: {
      type: String,
    },
  },
  components: {
    // AdlView,
  },
  data: () => ({
    headers: [
      {
        text: "Date",
        align: "start",
        sortable: true,
        value: "Date",
      },
      { text: "Client", value: "Client.Name" },
      { text: "Program", value: "Client.Program" },
      { text: "Service", value: "Service.Item" },
      { text: "Assistance", value: "Assistance" },
      { text: "Signature", value: "Signature" },
      { text: "Status", value: "status" },
      { text: "Action", value: "select" },
    ],
    defaultHeader: [
      {
        text: "Date",
        align: "start",
        sortable: true,
        value: "Date",
      },
      { text: "Client", value: "Client.Name" },
      { text: "Program", value: "Client.Program" },
      { text: "Service", value: "Service.Item" },
      { text: "Assistance", value: "Assistance" },
      { text: "Signature", value: "Signature" },
      { text: "Status", value: "status" },
      { text: "Action", value: "select" },
    ],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    clients: [],
    adls: [],
    programs: [],
    status: ["Signed", "Unsigned"],
    selectedStatus: "",
    startDate: "",
    endDate: "",
    ClientID: "",
    calendarMenu: false,
    calendar2Menu: false,
    report: "",
    clientName: "",
    isLoading: false,
    program: "",
    userState: localStorage.getItem("userState"),
    states: ["Utah", "Nevada"],
    isUtahIncidentReports: true,
    requiredField: [(v) => !!v || "This is required"],
    model: "tab-2",
    text: "",
    dialog: false,
    assistance: [
      "Independant",
      "Minimal Assistance",
      "Moderate Assistance",
      "Total Assistance",
    ],
    exception: ["Refused", "ADL on Hold", "Absent", "Other"],
    titleForm: "Viewing Unsigned ADL",
    newService: "",
    newTime: "",
    newAssistance: "",
    newException: "",
    newNotes: "",
    editADL: false,
    newSignature: "",
    adlID: "",
    msg: "",
    requiredRules: [(v) => !!v || "This is required"],
  }),

  computed: {
    ...mapGetters("timezones", ["getUserTimezone", "getDefaultTz"]),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },
  },

  created() {
    this.getClients();
    this.getPrograms();
  },

  methods: {
    initialize() {
      this.clients = [];
    },

    canUpdate() {
      if (
        localStorage.getItem("userRole") == "Administration" ||
        localStorage.getItem("userRole") == "Program Coordinator" ||
        localStorage.getItem("userRole") == "Client Services Manager" ||
        localStorage.getItem("userRole") == "Medical Manager" ||
        localStorage.getItem("userRole") == "Compliance Manager" ||
        localStorage.getItem("userRole") == "Human Resources"
      ) {
        return true;
      }
      return false;
    },

    async getClients () {
      let params = {};
      let endpoint = `${url}/clients`;

      const companyIds = localStorage.getItem('userCompanies');

      params['Company:in'] = JSON.parse(companyIds);
      params['State'] = this.userState;

      await axios.get(endpoint,{params})
      .then((res) => {
          this.clients = res.data.clients;
      });
    },

    async getPrograms () {
      const companyIds = localStorage.getItem('userCompanies');

      await axios.get(`${url}/units/state/${this.userState}`,{
          params: {
              Company: JSON.parse(companyIds)
          }
      })
      .then((res) => {
          this.programs = res.data.units;
      });
    },

    close() {
      this.dialog = false;
    },

    adlQuery() {
      axios
        .get(
          `${url}/unsignedADL/${this.ClientID}/${this.startDate}/${this.endDate}`
        )
        .then((res) => {
          console.log(res);
        });
    },

    test() {
      this.adls = [];
      this.isLoading = true;
      if (this.ClientID == "") {
        axios
          .get(`${url}/unsignedADL/${this.startDate}/${this.endDate}`)
          .then((res) => {
            var temp = res.data.unsigned;

            //make sure the user only sees data for the state their assigned to
            for (var i = 0; i < temp.length; i++) {
              if (this.userState == temp[i].clientID.State) {
                this.adls.push(temp[i]);
              }
            }

            // this.adls = this.adls.map(adl => {
            //   const adlCopy = adl;
            //   adlCopy.clientID.ProgramString = adl.clientID.Program.toString();
            //   return adlCopy;
            // });

            this.isLoading = false;
            this.headers = [
              {
                text: "Date",
                align: "start",
                sortable: false,
                value: "date",
              },
              { text: "Client", value: "clientID.Name" },
              { text: "Program", value: "clientID.Program" },
              { text: "Service", value: "services.ServiceItem" },
              { text: "Signature", value: "Signature" },
              { text: "Action", value: "select" },
              // { text: "", value: "select" },
            ];
          });
      } else {
        axios
          .get(
            `${url}/unsignedADL/${this.ClientID}/${this.startDate}/${this.endDate}`
          )
          .then((res) => {
            var temp = res.data.unsigned;
            for (var i = 0; i < temp.length; i++) {
              if (this.userState == temp[i].clientID.State) {
                this.adls.push(temp[i]);
              }
            }
            this.isLoading = false;
            this.headers = [
              {
                text: "Date",
                align: "start",
                sortable: false,
                value: "date",
              },
              { text: "Client", value: "clientID.Name" },
              { text: "Program", value: "clientID.Program" },
              { text: "Service", value: "services.ServiceItem" },
              { text: "Signature", value: "Signature" },
              { text: "Action", value: "select" },
              // { text: "", value: "select" },
            ];
          });
      }

      //   this.isLoading = true;
      //   const params = {
      //     clientID: this.ClientID,
      //     startDate: this.startDate,
      //     endDate: this.endDate,
      //     program: this.program,
      //     status: this.selectedStatus,
      //   };

      //   axios
      //     .get(`${url}/adl/adlReports`, {
      //       params,
      //     })
      //     .then((res) => {
      //       this.isLoading = false;
      //       this.adls = [];
      //       let tempData = res.data.data;
      //       console.log(tempData);
      //       this.isLoading = false;

      //       this.adls = tempData.map((item) => {
      //         return {
      //           ...item,
      //           Date: tz(item.Date, this.userTimezone).format("YYYY-MM-DD"),
      //         };
      //       });
      //       this.tableHeader(this.selectedStatus);
      //     });
      // },

      // tableHeader(status) {
      //   console.log(status);
      //   if (status === "Unsigned") {
      //     return (this.headers = [
      //       {
      //         text: "Date",
      //         align: "start",
      //         sortable: true,
      //         value: "Date",
      //       },
      //       { text: "Client", value: "Client.Name" },
      //       { text: "Program", value: "Client.Program" },
      //       { text: "Service", value: "services.ServiceItem" },
      //       { text: "Scheduled Time", value: "services.ScheduledTime" },
      //       { text: "Days", value: "services.Days" },
      //       { text: "Status", value: "status" },
      //     ]);
      //   }

      //   this.headers = this.defaultHeader;
    },

    // getClientID(item) {
    //   this.client = item.ClientID._id;
    //   window.localStorage.setItem("clientId", this.client);
    //   console.log(this.client);
    // },

    onUpdateItem() {
      var data = {
        Date: this.newDate,
        Time: this.newTime,
        Assistance: this.newAssistance,
        Exception: this.newException,
        Notes: this.newNotes,
        ClientID: this.clientID,
        Signature: this.newSignature,
        UrlNotification: this.$router.history.current.path,
      };
      axios.put(`${url}/adl`, data).then((res) => {});
    },

    viewADL(item) {
      console.log(item + " item");
      // this.editADL = true;
      this.dialog = true;
      this.newService = item.services.ServiceItem;
      this.newTime = item.services.ScheduledTime;
      this.newAssistance = item.services.Assistance;
      this.newException = item.services.Exception;
      this.newNotes = item.services.Notes;
      this.newSignature = item.services.Signature;
      this.adlID = item._id;
    },

    onUpdateSignature() {
      this.$emit("updateSignature");
      this.$nextTick(() => {
        this.newSignature = this.updatedSignature;
      });
    },

    printTable() {
      window.print();
    },
  },
};
</script>
<style>
#print {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
